module.exports = __webpack_public_path__ + "img/sendIcon.b52cb3c8.svg";